import React from "react"
import FeaturedCategoriesList from "../components/featuredCategoriesList"
import Layout from "../components/layout"
import HomeHero from "../components/homeHero"
import SEO from "../components/seo"
import TextBlock from "../components/textBlock"
import TextWithImageBlock from "../components/textWithImageBlock"
import { graphql } from "gatsby"
import { getHomePath } from "../utils/pathUtils"

const IndexPage = ({ data: { page, site }, location, pageContext }) => {
  const i18nPaths = site.locales.map(locale => {
    return {
      locale: locale,
      value: getHomePath(locale),
    }
  })

  return (
    <Layout locale={pageContext.locale} location={location} i18nPaths={i18nPaths}>
      <SEO title="Home" lang={pageContext.locale}/>
      {page.content.map(section => (
        <section key={section.id}>
          {section.model.apiKey === "text_block" && (
            <TextBlock section={section} />
          )}
          {section.model.apiKey === "people_slider" && (
            <HomeHero section={section} locale={pageContext.locale} />
          )}
          {section.model.apiKey === "text_with_image_block" && (
            <TextWithImageBlock section={section} />
          )}
          {section.model.apiKey === "featured_categories_list" && (
            <FeaturedCategoriesList section={section} />
          )}
        </section>
      ))}
    </Layout>
  )
}

export default IndexPage

export const query = graphql`
  query HomeQuery($id: String!) {
    site: datoCmsSite {
      locales
    }
    page: datoCmsHomePage(id: { eq: $id }) {
      id
      title
      locale
      content {
        ... on DatoCmsPeopleSlider {
          id
          model {
            apiKey
          }
          slides {
            id
            title
            body
            images {
              originalId
              fluid(maxWidth: 1920, maxHeight: 980) {
                ...GatsbyDatoCmsFluid
              }
            }
            page {
              id
              slug
              locale
              ...pageParent
              ...AllSlugLocales
            }
          }
        }
        ... on DatoCmsTextBlock {
          id
          title
          body
          model {
            apiKey
          }
        }
        ... on DatoCmsTextBlock {
          id
          title
          body
          model {
            apiKey
          }
        }
        ... on DatoCmsTextWithImageBlock {
          id
          title
          body
          alignement
          dark
          label
          imageGallery {
            fluid(maxWidth: 540) {
              ...GatsbyDatoCmsFluid
            }
          }
          model {
            apiKey
          }
        }
        ... on DatoCmsFeaturedCategoriesList {
          id
          title
          body
          model {
            apiKey
          }
          categories {
            id
            name
            shortName
            slug
            root
            locale
            ...AllProductCategorySlugLocales
            image {
              fluid(maxWidth: 700) {
                ...GatsbyDatoCmsFluid
              }
            }
          }
        }
      }
    }
  }
`
